export function getNewsArchive(store) {
  return store.news.newsArchive;
}

export function getNewsCurrent(store) {
  return store.news.newsCurrent;
}
